/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark } = colors;
export default {
  html: {
    scrollBehavior: "smooth",
    overflowX: "hidden",
  },
  body: {
    overflowX: "hidden",
    background: "#f5f7fa",
    backgroundAttachment: "fixed",
    minHeight: "100vh",
    color: "#1e293b",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  "img, svg, video": {
    maxWidth: "100%",
    height: "auto",
  },
  "label, .MuiInputLabel-root, .MuiFormLabel-root, .MuiFormControlLabel-label, .MuiFormLabel-root *": {
    userSelect: "none !important",
    WebkitUserSelect: "none !important",
    MozUserSelect: "none !important",
    msUserSelect: "none !important",
    pointerEvents: "none",
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

